export const ua = {
  'Log Out': 'Вийти',
  'Properties': 'Properties',
  'Fields': 'Поля',
  'Save Form': 'Зберігти форму',
  'Duplicate Form':'Дублювати форму',
  'Assignments':'Assignments',
};
